import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { BackdropCircular, Breadcrumb } from 'components';
import { getBrands, getStoreProductsApi } from 'api';
import {
  Card,
  Grid,
  Typography,
  LinearProgress,
  Fab,
  Tabs,
  Tab,
} from '@material-ui/core';
import { TabPanel, TabContext } from '@material-ui/lab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ScrollTop from 'components/ToolbarMenu/ScrollOnTop';
import BrowseBrandsTreatments from './browseBrandsTreatments';
import BrowseBrandsProducts from './browseBrandsProducts';


export default function BrowseBrand() {
  const dispatch = useDispatch();
  const { storeView } = useParams<{storeView: string}>();
  const {
    browseBrandsTreatments,
    browseBrandsProducts,
    browseBrandsGifts,
    loading: loadingBrands
  } = useSelector((state: IReduxState) => state.brands);
  const {store_products, loading, error} = useSelector((state: IReduxState) => state.products);
  const userStore = useSelector((state: IReduxState) => state.user?.profile?.stores?.[0]);
  const scrolledContainerRef = useRef(null);
  const [tabIndex, setTabIndex] = useState('0');

  useEffect(() => {
    if (browseBrandsProducts.length === 0) {
      getBrands({dispatch, skuLike: 'PROD'});
    }

    if (browseBrandsTreatments.length === 0) {
      getBrands({dispatch, skuLike: 'TREAT'});
    }

    if (browseBrandsGifts.length === 0) {
      getBrands({dispatch, skuLike: 'GIFT'});
    }

    if (!store_products.catalogProducts && userStore?.isCreated) {
      getStoreProductsApi({dispatch});
    }
  }, [userStore]);

  const handleTabChange = (e, value) => {
    setTabIndex(value);
  };

  const browseBrandsProductsAndGifts = [...browseBrandsProducts, ...browseBrandsGifts];
  browseBrandsProductsAndGifts.sort((a, b) => a.value.localeCompare(b.value));

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y" ref={scrolledContainerRef}>
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            {
              name: `${storeView == 'quote' ? 'Quote' : ''} Listings`,
              path: `${storeView == 'quote'
                ? '/quoting/listings/active'
                : '/store-products/list/active'
              }`
            },
            {
              name: `Browse ${storeView == 'quote' ? 'Quote' : ''} Listings`,
              path: `/browse-brand/${storeView}`
            },
          ]}
        />
      </div>
      {!loading && error && <div>Something went wrong</div>}
      {loading && !error && <LinearProgress className="m-10" />}
      {!loading && !error &&
      <Card className="m-10 p-7">
        <Grid container className="pb-12">
          <Grid item xs={12} className="flex justify-between items-center mb-8">
            <Typography variant="h1" className="w-full">
              {`Browse ${storeView == 'quote' ? 'Quote' : ''} Listings`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TabContext value={tabIndex}>
              <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                className={'mx-10'}
              >
                <Tab className="capitalize font-medium" value={'0'} label="Products" />
                <Tab className="capitalize font-medium" value={'1'} label="Treatments " />
              </Tabs>
              <TabPanel value={'0'}>
                <BrowseBrandsProducts results={browseBrandsProductsAndGifts} />
              </TabPanel>
              <TabPanel value={'1'}>
                <BrowseBrandsTreatments results={browseBrandsTreatments} />
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </Card>
      }
      <ScrollTop refEl={scrolledContainerRef.current}>
        <Fab color="secondary" className="text-white bg-primary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
      <BackdropCircular loading={loadingBrands} />
    </div>
  );
}
